import { Header, Text } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants';

export const LoadingText = Text.withConfig({
  margin: '0',
  fontWeight: 'black',
  textAlign: 'center',
  fontSize: 'md',
  lineHeight: 'md',
});

export const ModalTitle = Header.withConfig({
  variant: 'headerTwo',
  textAlign: 'center',
});

export const AddressInfoLine = Header.withConfig({
  variant: 'headerThree',
  margin: '0',
  marginTop: '$5',
  marginBottom: '1',
});

export const AliasOptions = Header.withConfig({
  variant: 'headerFour',
  margin: '0',
});

export const AliasOptionText = Text.withConfig({
  fontSize: 'sm',
  fontWeight: '600',
  color: '$brown600',
});

export const AliasOptionTextSelected = AliasOptionText.withConfig({
  color: '$white',
});

export const deliveryAddressFormHeaderStyles = StyleSheet.create({
  modalHeading: {
    paddingVertical: 16,
    paddingHorizontal: 12,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  side: {
    width: '20%',
    alignItems: 'flex-start',
  },
  center: {
    width: '60%',
    alignItems: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: primitive.$bbqBrown,
    textAlign: 'center',
  },
});

export const DialogStyles = StyleSheet.create({
  headingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  bodyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingBottom: 16,
  },
});

export const lockInputStyle = StyleSheet.create({
  lockedContainer: {
    paddingVertical: 15,
    minHeight: 30,
    borderWidth: 1,
    borderColor: '#D1D5DB',
    borderRadius: 4,
    backgroundColor: '#F3F4F6',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
  },
  lockedText: {
    flex: 1,
    fontFamily: 'Flame-RegularSans',
    color: '#6B7280',
  },
  iconContainer: {
    marginLeft: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
